<!--
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-11-21 17:23:43
 * @LastEditors: Andy
 * @LastEditTime: 2022-11-24 16:13:11
-->
<template>
  <component :is="type" v-bind="linkProps(to)">
    <slot />
  </component>
</template>

<script>
  import { isExternal } from '@main/common/utils/validate'

  export default {
    props: {
      to: {
        type: [String, Object],
        required: true
      }
    },
    computed: {
      isExternal() {
        return isExternal(this.to)
      },
      type() {
        if (this.isExternal) {
          return 'a'
        }
        return 'router-link'
      }
    },
    methods: {
      linkProps(to) {
        if (this.isExternal) {
          return {
            href: to,
            target: '_blank',
            rel: 'noopener'
          }
        }
        return {
          to
        }
      }
    }
  }
</script>
